import React from 'react'

export default function LoaderMineralCountriesList() {
  return [...Array(21)].map((_, index) => (
    <div className="flex w-full animate-pulse border-2 border-muted-500 bg-muted-100">
      <div className="h-14"></div>
    </div>
  ))
}
